import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIRoutes } from '../global-misc/api-routes';
import { firstValueFrom } from 'rxjs';
import { CreateUserModel, UpdateUserModel, UserModel } from '../global-data-models/user.model';
// Import the new User models

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private http: HttpClient) {}

  async adminGetUserById(userId: string): Promise<UserModel> {
    const apiRoute = APIRoutes.SINGLE_USER_ROUTE.replace(':userId', userId);
    return await firstValueFrom(this.http.get<UserModel>(apiRoute));
  }

  async adminUpdateUser(userId: string, user: UpdateUserModel): Promise<UserModel> {
    const apiRoute = APIRoutes.SINGLE_USER_ROUTE.replace(':userId', userId);
    return await firstValueFrom(this.http.patch<UserModel>(apiRoute, user));
  }

  async meGetUser(): Promise<UserModel> {
    const apiRoute = APIRoutes.ME_ROUTE;
    return await firstValueFrom(this.http.get<UserModel>(apiRoute));
  }
  async meUpdateUser(user: UpdateUserModel): Promise<UserModel> {
    const apiRoute = APIRoutes.ME_ROUTE;
    return await firstValueFrom(this.http.patch<UserModel>(apiRoute, user));
  }

  async orgAdminGetUserById(userId: string, orgId: string): Promise<UserModel> {
    const apiRoute = APIRoutes.SINGLE_ORG_USERS_ROUTE.replace(':orgId', orgId).replace(':userId', userId);
    return await firstValueFrom(this.http.get<UserModel>(apiRoute));
  }

  async orgAdminUpdateUser(userId: string, orgId: string, user: UpdateUserModel): Promise<UserModel> {
    const apiRoute = APIRoutes.SINGLE_ORG_USERS_ROUTE.replace(':orgId', orgId).replace(':userId', userId);
    return await firstValueFrom(this.http.patch<UserModel>(apiRoute, user));
  }

  async orgAdminCreateUser(user: CreateUserModel, orgId:string): Promise<UserModel> {
    const apiRoute = APIRoutes.ORG_USERS_ROUTE.replace(':orgId', orgId);
    return await firstValueFrom(this.http.post<UserModel>(apiRoute, user));
  }

  async orgAdminDeleteUser(userId: string, orgId: string): Promise<void> {
    const apiRoute = APIRoutes.SINGLE_ORG_USERS_ROUTE.replace(':orgId', orgId).replace(':userId', userId);
    return await firstValueFrom(this.http.delete<void>(apiRoute));
  }

  async sysAdminCreateUser(user: CreateUserModel): Promise<UserModel> {
    const apiRoute = APIRoutes.USERS_ROUTE;
    return await firstValueFrom(this.http.post<UserModel>(apiRoute, user));
  }

  // Method to update an existing user
  async updateUser(userId: string, user: UpdateUserModel): Promise<UserModel> {
    const apiRoute = APIRoutes.SINGLE_USER_ROUTE.replace(':userId', userId);
    // Use PATCH or PUT as appropriate for your API
    return await firstValueFrom(this.http.patch<UserModel>(apiRoute, user));
  }

  // Method to get users within a specific organisation
  async getOrgUsers(orgId: string): Promise<UserModel[]> {
    const apiRoute = APIRoutes.ORG_USERS_ROUTE.replace(':orgId', orgId);
    return await firstValueFrom(this.http.get<UserModel[]>(apiRoute));
  }

  // Add other methods as needed (e.g., deleteUser, getAllUsers for sysAdmin)
}
